module.exports = __webpack_public_path__ + "img/1a1fd49.png";